import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  itemStatusEdit: {},
  isLoading: false,
  showDialog: false,
};

//STORE SLICE
export const itemStatusEditSlice = createSlice({
  name: "itemStatusEditSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showEditItemStatusDialog(state, action) {
      return {
        ...state,
        showDialog: true,
        itemStatusEdit: action.payload,
      };
    },
    closeEditItemStatusDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },    
  },
});

//ACTIONS
export const {
  showEditItemStatusDialog,
  closeEditItemStatusDialog,
  showLoading,
  hideLoading
} = itemStatusEditSlice.actions;

export default itemStatusEditSlice.reducer;
